import React, { Component } from "react";
import Chart from "chart.js";
// import axios from "axios";
// import { logger } from "../../util/logger";
import { getChartData, getExchangeRate } from "../../util/utils";

export default class usdcGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btcPrice: "",
      btcNgnPrice: 0,
      btcGhsPrice: 0,
      chartData: {},
    };
  }

  loadPrices = async () => {
    const ngnPrice = await getExchangeRate("usdngn", "buy");
    const ghsPrice = await getExchangeRate("usdghs", "buy");
    //const usdPrice = await getExchangeRate("usd", "buy");

    this.setState({
      usdcNgnPrice: ngnPrice,
      usdcGhsPrice: ghsPrice,
      //usdcPrice: usdPrice,
    });

    localStorage.setItem("usdcNgnPrice", this.state.usdcNgnPrice);
  };

  loadChartPrices = async () => {
    try {
      const chartData = await getChartData("usd-coin");
      this.setState({ chartData });
    } catch (err) {
      if (err.isAxiosError) {
        // const errData = err.response;
        if (err.isAxiosError) {
          if (err.response.status === 401 || err.response.status === 403) {
            window.location = "/";
          }
        }
      }
    }
  };

  async componentDidMount() {
    // Storage.prototype.setObj = function (key, obj) {
    //   return this.setItem(key, JSON.stringify(obj));
    // };
    // Storage.prototype.getObj = function (key) {
    //   return JSON.parse(this.getItem(key));
    // };

    await this.loadChartPrices();
    let myChart1 = document.getElementById("myChart1").getContext("2d");
    ///
    Chart.defaults.global.defaultFontSize = 12;
    //Chart.defaults.global.defaultFontColor = '#557de2';
    Chart.defaults.global.defaultFontColor = "#14142b4f";

    // let axiosConfig = {
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // };
    //
    // axios
    //   .get(`https://api.coindesk.com/v1/bpi/historical/close.json`, axiosConfig)
    //   .then((res) => {
    //     localStorage.setObj("realDates", Object.keys(res.data.bpi));
    //     localStorage.setObj("realDataa", Object.values(res.data.bpi));
    //   })
    //   .catch((err) => {
    //     logger("AXIOS ERROR: ", err);
    //   });
    //
    // const reDates = localStorage.getObj("realDates");
    // const reData = localStorage.getObj("realDataa");

    new Chart(myChart1, {
      type: "line", // bar, horizontalBar, pie, line, doughnut, radar, polarArea
      data: {
        labels: this.state.chartData.dates,
        datasets: [
          {
            label: "Amount",
            // fill: false,
            lineTension: 0,
            backgroundColor: "#d387312c",
            borderColor: "#d364312c",
            // backgroundColor: "rgba(255, 255, 255, 0.151)",
            borderWidth: 1.5,

            //borderColor: "#027e4aea",
            //hoverBorderWidth:3,
            //hoverBorderColor:'#000'
            pointRadius: 0,
            // pointBorderWidth:2,
            // pointHoverRadius:7,
            //pointHoverBorderWidth:10,
            //pointBorderColor:'white',
            pointBackgroundColor: "white",
            //pointHoverBackgroundColor:'#bcc',
            pointRotation: 1,
            data: this.state.chartData.prices,
          },
        ],
      },
      options: {
        // title: {
        //     display: false,
        //     text: 'Amounts in USD',
        //     fontSize: 25,
        //     fontColor:'white'
        // },
        legend: {
          display: false,
          position: "right",
          labels: {
            fontColor: "white",
          },
        },
        //maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                //min: 10000,
                beginAtZero: true,
                showLabelBackdrop: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],

          xAxes: [
            {
              gridLines: {
                offsetGridLines: false,
                display: false,
              },
              ticks: {
                //min: 10000,
                beginAtZero: false,
                showLabelBackdrop: true,
              },
            },
          ],
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
          },
        },

        tooltips: {
          enabled: true,
        },
      },
    });
    await this.loadPrices();
  }
  render() {
    return (
      <div>
        <div>
          <section className="chart1">
            <p className="crypto-prices">
              1 USDC = 1 USD,{" "}
              {Number(this.state.usdcNgnPrice).toLocaleString() + " "} NGN,{" "}
              {Number(this.state.usdcGhsPrice).toLocaleString() + " "} GHS
            </p>
            <canvas id="myChart1" className="canvas-ch" height="130"></canvas>
          </section>
        </div>
      </div>
    );
  }
}
